module.exports = __webpack_public_path__ + "media/images/emoticons/horse-fe649192bdfddc49f17fa6177aa06806.gif";